import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {DashboardModule} from '@/util/dashboard';
import {PropType} from 'vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'AppDashboardModule',
  props: {
  mod: {
    type: Object as PropType<DashboardModule>,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!

  return (_openBlock(), _createBlock(_component_v_btn, {
    color: __props.mod.outlined ? undefined : __props.mod.color,
    theme: !__props.mod.outlined ? 'dark' : undefined,
    to: (__props.mod.actions && __props.mod.actions.length > 0) ? __props.mod.actions[0].to : undefined,
    variant: __props.mod.outlined ? 'outlined' : undefined,
    class: _normalizeClass(`btn-card py-3 ${__props.mod.outlined ? [`text-${__props.mod.color}`] : []}`),
    block: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_list_item, {
        class: _normalizeClass(`dashboard-btn-content ${__props.mod.outlined ? `text-${__props.mod.color}` : ''}`)
      }, {
        append: _withCtx(() => [
          _createVNode(_component_v_icon, {
            class: "dashboard-icon",
            color: __props.mod.outlined ? __props.mod.color : (__props.mod.color === 'primary' ? 'secondary' : '')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.mod.icon), 1)
            ], undefined, true),
            _: 1
          }, 8, ["color"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_list_item_title, { class: "text-h5 mb-1" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.mod.name), 1)
            ], undefined, true),
            _: 1
          }),
          _createVNode(_component_v_list_item_subtitle, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.mod.desc), 1)
            ], undefined, true),
            _: 1
          })
        ], undefined, true),
        _: 1
      }, 8, ["class"]),
      (__props.mod.actions && __props.mod.actions.length > 1)
        ? (_openBlock(), _createBlock(_component_v_card_actions, { key: 0 }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.mod.actions, (action) => {
                return (_openBlock(), _createBlock(_component_v_btn, {
                  key: action.to.name,
                  to: action.to,
                  color: action.color ? action.color : 'white',
                  theme: "light"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(action.name), 1)
                  ], undefined, true),
                  _: 2
                }, 1032, ["to", "color"]))
              }), 128))
            ], undefined, true),
            _: 1
          }))
        : _createCommentVNode("", true)
    ], undefined, true),
    _: 1
  }, 8, ["color", "theme", "to", "variant", "class"]))
}
}

})